import React, { useEffect, useRef, useState } from "react";
import { ShieldCheck, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const SafeguardingOfficerSection = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const responsibilities = t("safeguardingOfficer.responsibilities") || [];

  return (
    <section id="officer" ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div
            className={`transition-all duration-700 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <div className="inline-flex items-center justify-center w-14 h-14 bg-[#E8792B]/10 rounded-xl mb-6">
              <ShieldCheck className="w-7 h-7 text-[#E8792B]" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] mb-4">
              {t("safeguardingOfficer.title")}
            </h2>
            <div className="w-20 h-1 bg-[#E8792B] rounded-full mb-6" />
            <p className="text-xl font-bold text-[#1a1a2e] leading-relaxed mb-4">
              {t("safeguardingOfficer.intro")}
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              {t("safeguardingOfficer.description")}
            </p>
          </div>

          <div
            className={`bg-gray-50 rounded-2xl p-8 border border-gray-100 transition-all duration-700 delay-200 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <h3 className="text-xl font-bold text-[#1a1a2e] mb-6">
              {t("safeguardingOfficer.responsibilitiesTitle")}
            </h3>
            <ul className="space-y-3">
              {Array.isArray(responsibilities) &&
                responsibilities.map((item, index) => (
                  <li key={index} className="flex items-start gap-3 group">
                    <CheckCircle2 className="w-5 h-5 text-[#E8792B] mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                    <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafeguardingOfficerSection;
